/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const bgsOrderRequestAPI = (jwt, payload) => {
    const wcEnv = {
        rootUri: '/mbp-canada-checkout',
    };

    const resourcePath = '/bgsOrderRequest';

    return restClient.postFacade(wcEnv, resourcePath, jwt, payload, null, null, false).then((response) => response).catch((error) => error?.response);
};

export default bgsOrderRequestAPI;
